// tslint:disable-next-line:no-submodule-imports
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, map , first } from "rxjs/operators";
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from "../../_base/crud";
import { ApiResponse } from "../../models/api-response.model";
import { InvoicingJobModel } from "./invoicing-job.model";
import { CampaignNumber } from "../../models/campaignNumber.model";
import { environment } from "../../../../environments/environment";
import { AsyncJobId } from "../../../persistence/dto/async-job-id.model";
import { HTTPRequestBuilder } from "../../../model/http.request.model";
import { HTTPService } from "../../../service/http.service";
import { HTTPMethod } from "../../../model/http-method.enum";
import { Country } from "../../../model/country.enum";


const API_INVOICING_URL = environment.API_URL + "api/invoicing";
const API_INVOICING_EXPORT = environment.API_URL + "api/invoicing/export";
const API_INVOICING_START_URL = environment.API_URL + "api/invoicing/enqueue";
const API_INVOICING_PDF_URL = environment.API_URL + "api/invoicing/generatePrintFiles";

@Injectable({
  providedIn: "root"
})
export class InvoicingJobListService {
  // TODO: NGRX error handling

  constructor(private http: HttpClient, private httpUtils: HttpUtilsService , private httpService: HTTPService) { }

  startInvoicingJob(campaignId: number, zone: number): Observable<ApiResponse> {
    const isUy = environment.country === Country.URUGUAY ? true : false;
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http
      .post<InvoicingJobModel>(API_INVOICING_START_URL, { campaignId, zone, isUy}, { headers: httpHeaders })
      .pipe(catchError((err) => of(null)));
  }

  generatePrintFiles(campaignId: number, zone: number): Observable<ApiResponse> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http
      .post<InvoicingJobModel>(API_INVOICING_PDF_URL, { campaignId, zone }, { headers: httpHeaders })
      .pipe(catchError((err) => of(null)));
  }

  findInvoicingJobs(queryParams: QueryParamsModel): Observable<QueryResultsModel<InvoicingJobModel>> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();

    const url = API_INVOICING_URL + "/find";
    return this.http
      .post<QueryResultsModel>(url, queryParams, { headers: httpHeaders })
      .pipe(catchError((err) => of(null)));
  }

  downloadGuide(invoicing: InvoicingJobModel) {
    const url = `${API_INVOICING_URL}/download?campaignId=${invoicing.campaignId}&zone=${invoicing.zone}`;
    window.open(url);
  }

  /**
     * @description
     *	Descargar reporte guide.pdf, para la campaña y zona especificada, de forma
     *	asincrónica.
     */

  downloadGuideAsync(invoicing: InvoicingJobModel): Observable<AsyncJobId> {
    return this.httpService.send<typeof undefined, AsyncJobId>(
        new HTTPRequestBuilder<typeof undefined>()
            .method(HTTPMethod.GET)
            .controllerPath(`api/invoicing`)
            .relativePath(`/downloadAsync?campaignId=${invoicing.campaignId}&zone=${invoicing.zone}`)
            .build())
        .pipe(map((response) => AsyncJobId.from(response)));
  }

  public downloadBarcode(orderId: number) {
    const url = `${API_INVOICING_URL}/download/barcode?orderId=${orderId}`;
    window.open(url);
  }

  exportExcel(url, method) {
    if (method === "get") {
      return this.http.get(url, { responseType: "blob" }).pipe(
        map((res) => {
          return new Blob([res], {
            type: "text/csv"
          });
        })
      );
    }
  }

  downloadInvoicing(campaign, division) {
    let url = `${API_INVOICING_EXPORT}?campaignId=${campaign}&Division=${division}`;
    return this.exportExcel(url, "get");
  }

  getGuideFileName(invoicing: InvoicingJobModel): Observable<CampaignNumber> {
		return this.httpService.send<typeof undefined, CampaignNumber>(
          new HTTPRequestBuilder<typeof undefined>()
                .method(HTTPMethod.GET)
                .controllerPath(`api/Campaigns`)
                .relativePath(`/translate?campaignId=${invoicing.campaignId}`)
                .build())
            .pipe(map((response) => CampaignNumber.from(response)));
  }

  reRunPoints(campaignId: number, zone: number): Observable<ApiResponse> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_INVOICING_URL + "/reRunPoints/" + campaignId + "/" + zone;
    return this.http
      .post<InvoicingJobModel>(url, {}, { headers: httpHeaders })
      .pipe(catchError((err) => of(null)));
  }
}
